/**
 * @author Jan Renkin
 *
 * This service keeps track of a page (state) with parameters.
 * It can redirect to the tracked page (and while doing so it overwrites the history-entry of the previous page)
 *
 */
'use strict';

var util = require('../util/property-util');
var arrayUtil = require('../util/array-util');

module.exports = /*@ngInject*/ ["$state", "ProjectService", function ($state, ProjectService) {
    var redirectState;  // json object that contains the name and the parameters of the current redirectState
    var previousState = undefined;
    var factory = {};

    /**
     * Sets the redirect page and state params, but only if it's a valid page (not login, index, 404..)
     * @param stateName     the name of the state
     * @param params        json object that contains the parameters
     */
    factory.setRedirectPage = function (stateName, params) {
        if (!shouldPreventPage(stateName)) {
            redirectState = {
                name: stateName,
                params: params
            }
        }
    };

    factory.getRedirectPage = function (stateName, params) {
        return redirectState;
    };

    factory.resetRedirectPage = function () {
        redirectState = undefined;
    };
    /**
     * Goes to the current redirect (if defined) with the saved parameters
     * It overwrites the previous state in the history (back button)
     */
    factory.gotoCurrentRedirectPath = function () {
        if (util.isDefined(redirectState)) {
            // replaces previous history entry
            $state.go(redirectState.name, redirectState.params, {location: "replace"});
        }
    };
    factory.gotoLoginPage = function (replace) {
        if (replace) {
            $state.go('login', undefined, {location: "replace"})
        } else {
            $state.go('login');
        }
    };

    factory.setPreviousState = function(state, params){
        previousState = {state:state, params:params};
    };

    factory.returnToPreviousState = function(){
        if (util.isDefined(previousState) &&  util.isDefined(previousState.state.name) && previousState.state.name != ""){
            $state.go(previousState.state, previousState.params);
        } else {
            $state.go("home", {projectId: ProjectService.getSelectedProjectId()});
        }
    };

    var shouldPreventPage = function (pagename) {
        var preventPages = ["login", "index", "error"];
        return arrayUtil.contains(preventPages, pagename);
    };
    return factory;
}];
